// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NormalUsage, NormalUsageT, verifyNormalUsage } from "./normal-usage";
import { UsageVariant, unionToUsageVariant, unionListToUsageVariant } from "./usage-variant";
import { ValuedUsage, ValuedUsageT, verifyValuedUsage } from "./valued-usage";

export class ElevatorUsageMessage implements flatbuffers.IUnpackableObject<ElevatorUsageMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorUsageMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorUsageMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorUsageMessage,
  ): ElevatorUsageMessage {
    return (obj || new ElevatorUsageMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorUsageMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorUsageMessage,
  ): ElevatorUsageMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorUsageMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  usageType(): UsageVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : UsageVariant.NONE;
  }

  usage<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startElevatorUsageMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addUsageType(builder: flatbuffers.Builder, usageType: UsageVariant) {
    builder.addFieldInt8(0, usageType, UsageVariant.NONE);
  }

  static addUsage(builder: flatbuffers.Builder, usageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, usageOffset, 0);
  }

  static endElevatorUsageMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // usage
    return offset;
  }

  static createElevatorUsageMessage(
    builder: flatbuffers.Builder,
    usageType: UsageVariant,
    usageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ElevatorUsageMessage.startElevatorUsageMessage(builder);
    ElevatorUsageMessage.addUsageType(builder, usageType);
    ElevatorUsageMessage.addUsage(builder, usageOffset);
    return ElevatorUsageMessage.endElevatorUsageMessage(builder);
  }

  unpack(): ElevatorUsageMessageT {
    return new ElevatorUsageMessageT(
      this.usageType(),
      (() => {
        const temp = unionToUsageVariant(this.usageType(), this.usage.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ElevatorUsageMessageT): void {
    _o.usageType = this.usageType();
    _o.usage = (() => {
      const temp = unionToUsageVariant(this.usageType(), this.usage.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ElevatorUsageMessageT {
    const t = new ElevatorUsageMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("usage_type")) {
      t.usageType = this.usageType();
    }
    if (fieldSet.has("usage")) {
      t.usage = (() => {
        const temp = unionToUsageVariant(this.usageType(), this.usage.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ElevatorUsageMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public usageType: UsageVariant = UsageVariant.NONE,
    public usage: NormalUsageT | ValuedUsageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.usage === null || this.usage === undefined) {
      throw new Error('Required field "usage" is not set');
    }
    const usage = builder.createObjectOffset(this.usage);

    return ElevatorUsageMessage.createElevatorUsageMessage(builder, this.usageType, usage);
  }

  clone(): ElevatorUsageMessageT {
    const obj = new ElevatorUsageMessageT();
    obj.usageType = this.usageType;
    obj.usage =
      this.usage !== null && typeof (this.usage as any).clone === "function"
        ? (this.usage as any).clone()
        : this.usage;
    return obj;
  }

  equals(other: ElevatorUsageMessageT): boolean {
    if (this.usageType !== other.usageType) return false;
    if (this.usage !== null && other.usage !== null) {
      if (typeof (this.usage as any).equals === "function") {
        if (!(this.usage as any).equals(other.usage)) return false;
      } else if (this.usage !== other.usage) return false;
    } else if (this.usage !== other.usage) return false;
    return true;
  }
}

export function verifyElevatorUsageMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "usage");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalUsage
            {
              const o = verifier.readInt32(pos);
              verifyNormalUsage(verifier, pos + o);
            }
            break;
          case 2: // ValuedUsage
            {
              const o = verifier.readInt32(pos);
              verifyValuedUsage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "usage");
  } finally {
    verifier.popDepth();
  }
}
